import { render } from "./MainBannerBigScreen.vue?vue&type=template&id=5bbd865c"
import script from "./MainBannerBigScreen.vue?vue&type=script&lang=js"
export * from "./MainBannerBigScreen.vue?vue&type=script&lang=js"

import "./MainBannerBigScreen.vue?vue&type=style&index=0&id=5bbd865c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__